import { IndustryConfig } from '../../../types'

export const healthcareDentalServicesConfig: IndustryConfig = {
  id: 'healthcare-dental-services',
  name: 'Healthcare & Dental Services',
  icon: '🏥',
  description: 'Healthcare and dental service providers focused on patient acquisition and service expansion',
  
  businessTypes: [
    {
      id: 'general-practice',
      name: 'General Practice',
      description: 'Family medicine, internal medicine, and general healthcare services'
    },
    {
      id: 'dental-practice',
      name: 'Dental Practice',
      description: 'General dentistry, orthodontics, and specialized dental services'
    },
    {
      id: 'specialty-practice',
      name: 'Specialty Medical Practice',
      description: 'Specialized medical services like cardiology, dermatology, or orthopedics'
    },
    {
      id: 'urgent-care',
      name: 'Urgent Care & Walk-in Clinics',
      description: 'Immediate care services and walk-in medical facilities'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'insurance-billing',
      name: 'Insurance Billing',
      description: 'Revenue from insurance reimbursements and managed care contracts',
      intelligenceValue: "We'll monitor insurance reimbursement rate changes, policy updates, and payer mix trends to help you optimize your revenue cycle and negotiate better contracts."
    },
    {
      id: 'cash-pay-services',
      name: 'Cash Pay Services',
      description: 'Direct-pay patients and elective procedures',
      intelligenceValue: "We'll track cash-pay market trends, pricing benchmarks, and patient demand for elective services to help you expand profitable self-pay offerings."
    },
    {
      id: 'specialized-procedures',
      name: 'Specialized Procedures',
      description: 'High-value procedures and specialized treatment services',
      intelligenceValue: "We'll monitor procedure volume trends, reimbursement rates, and competitor offerings to help you identify and expand high-margin specialized services."
    },
    {
      id: 'ancillary-services',
      name: 'Ancillary Services',
      description: 'Lab work, imaging, pharmacy, and additional healthcare services',
      intelligenceValue: "We'll track ancillary service demand, pricing opportunities, and regulatory changes to help you add profitable complementary services to your practice."
    }
  ],
  
  supplierCategories: [
    {
      id: 'medical-equipment',
      name: 'Medical Equipment',
      suppliers: ['Equipment manufacturers', 'Medical device distributors', 'Imaging equipment providers', 'Dental equipment suppliers', 'Technology vendors'],
      spendRanges: ['Under $10K', '$10K-$50K', '$50K-$200K', 'Over $200K']
    },
    {
      id: 'supplies-pharmaceuticals',
      name: 'Supplies & Pharmaceuticals',
      suppliers: ['Medical supply distributors', 'Pharmaceutical suppliers', 'Lab supply companies', 'Disposable supply vendors', 'Specialty suppliers'],
      spendRanges: ['Under $5K', '$5K-$25K', '$25K-$100K', 'Over $100K']
    },
    {
      id: 'practice-management',
      name: 'Practice Management',
      suppliers: ['EHR/EMR systems', 'Practice management software', 'Billing services', 'Scheduling systems', 'Communication platforms'],
      spendRanges: ['Under $3K', '$3K-$15K', '$15K-$50K', 'Over $50K']
    },
    {
      id: 'facility-operations',
      name: 'Facility & Operations',
      suppliers: ['Office rent/lease', 'Insurance providers', 'Cleaning services', 'Utilities', 'Security systems'],
      spendRanges: ['Under $5K', '$5K-$20K', '$20K-$75K', 'Over $75K']
    }
  ],
  
  competitiveFactors: [
    'Patient satisfaction scores',
    'Location convenience',
    'Wait times and availability',
    'Insurance acceptance',
    'Technology adoption',
    'Specialist referrals',
    'Reputation and reviews',
    'Service breadth',
    'Quality outcomes',
    'Staff expertise'
  ]
}